import axios from 'axios';
import { toast } from 'react-toastify';
import logger from './logService';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response && error.response.status >= 400 && error.response.status <= 500;

  if (!expectedError) {
    return toast.error('An unexpected error has occured.');
  }
  
  logger.log(error);  
  return Promise.reject({ status: error.message, message: error.response.data });
});

function setJwt(jwt) {
  axios.defaults.headers.common['x-auth-token'] = jwt;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
};
